import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./Pages/Login";
import HomePage from "./Pages/Home";
import ListingPage from "./Pages/ListingPage";
import Pricing from "./Pages/pricingPage";
import AdsOnPage from "./Pages/adsOn";
import ProfilePage from "./Pages/Profile";
import BookingPage from "./Pages/BookingPage";
import NoBookingPage from "./Pages/NoBookingPage";
import ProtectedRoute from "./ProtectedRoute";

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        {/* Public Route */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/Home" element={<Navigate to="/" replace />} />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <HomePage/>
            </ProtectedRoute>
          }
        />

        <Route
          path="/listing-page"
          element={
            <ProtectedRoute>
              <ListingPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/pricing"
          element={
            <ProtectedRoute>
              <Pricing />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ads-on"
          element={
            <ProtectedRoute>
              <AdsOnPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <ProfilePage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/bookings"
          element={
            <ProtectedRoute>
              <BookingPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/no-bookings"
          element={
            <ProtectedRoute>
              <NoBookingPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default AppRouter;
